import {isLocalLink} from './isLocalLink';

export function openLink(url, {replaceHistory = false, popupCallback} = {}) {
    const externalURL = app.store.getState().ui.sidePanel.externalURL;

    if (isLocalLink(url)) {
        let path = url.replace(/^https?\:\/\/.+?\//, '/');
        console.log('Local path detected / jumping to ', path);
        if (replaceHistory) {
            app.history.replace(path);
        } else {
            app.history.push(path);
        }
    } else if (url.match(/youtube\.com\/embed/) && popupCallback) {
        popupCallback(url);
    } else if (url.match(/youtube\.com\/embed/) && !externalURL) {
        app.store.dispatch(app.actions.ui.sidePanel.openExternalURL(url, false));
    } else if (url.match(/player.vimeo.com/) && popupCallback) {
        popupCallback(url);
    } else if (url.match(/(?:iframe|player)\.mediadelivery\.net/) && popupCallback) {
        popupCallback(url);
    } else {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}

export function openExternalURL({url, target, eventId, programId, meetingId, maximize}) {
    if (target === 'iframe') {
        if (programId) {
            app.store.dispatch(app.actions.ui.sidePanel.openProgramVirtualRoom(eventId, programId, url, maximize));
        } else if (meetingId) {
            app.store.dispatch(app.actions.ui.sidePanel.openMeetingVirtualRoom(eventId, meetingId, url, maximize));
        } else {
            app.store.dispatch(app.actions.ui.sidePanel.openExternalURL(url, maximize));
        }
    } else {
        openLink(url);
    }
}
